import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Sysidname } from '../entity/Sysidname-angular';

export interface SysidnameData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     SYSIDFIELD: string;            // 欄位FIELD 12     SYSIDID: string;            // 代號 2 940614 MODI 1->2    SYSIDNAME: string;            // 對照名稱 20     SYSIDPS: string;            // 說明 30 }


@Injectable({
  providedIn: 'root'
})
export class SysidnameServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Sysidname(); 
    this.entityType.type = EntityType.data;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        SYSIDFIELD : '欄位FIELD' , SYSIDID : '代號' , SYSIDNAME : '對照名稱' , SYSIDPS : '說明'  }; 

    this.fieldNames = 'SYSIDFIELD,SYSIDID,SYSIDNAME,SYSIDPS' ;
    this.fieldLengths = {SYSIDFIELD : 12 ,SYSIDID : 2 ,SYSIDNAME : 20 ,SYSIDPS : 30 } ;
    this.columnDefs = [
      { field: "SYSIDFIELD", headerName: "欄位FIELD",headerTooltip: "",width:166,cellDataType: "text", },
      { field: "SYSIDID", headerName: "代號",headerTooltip: "",width:86,cellDataType: "text", },
      { field: "SYSIDNAME", headerName: "對照名稱",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "SYSIDPS", headerName: "說明",headerTooltip: "",width:250,cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSIDNAME' ;
    this.isSys =true; 
    this.sqlSelect = `SELECT SYSIDNAME.*  FROM SYSIDNAME` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY SYSIDFIELD,SYSIDID` ;
    this.keyFields = ['SYSIDFIELD','SYSIDID'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['SYSIDFIELD','SYSIDID'];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Sysidname): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Sysidname): Promise<Sysidname> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

